import {DomainObject} from 'shared/store';
import {action, computed, observable} from 'mobx';
import {Employee} from 'stores/employees';
import {rangeDate} from 'shared/tools';
import ProgressUpdate from './ProgressUpdate';
import {t} from 'shared/core';
import _ from 'lodash';

class Goal extends DomainObject {
  @observable title;
  @observable description;
  @observable startDate;
  @observable endDate;
  @observable completeness;
  @observable createdAt;
  @observable completedAt;
  @observable employee;
  @observable progressUpdates;

  @action merge(other) {
    super.merge(other, {
      employee: Employee,
      progressUpdates: [ProgressUpdate],
      _dates: ['startDate', 'endDate', 'createdAt', 'completedAt']
    });
  }

  @computed get startDateView() {
    return rangeDate(this.startDate);
  }

  @computed get endDateView() {
    return rangeDate(this.endDate);
  }

  @computed get titleView() {
    if (this.title) {
      return this.title;
    } else {
      return t('goals.Untitled Goal');
    }
  }

  @computed get sortedProgressUpdates() {
    return _.orderBy(this.progressUpdates, 'createdAt', 'desc');
  }

  @computed get progressBarItems() {
    return [
      { label: 1, value: this.completeness, color: '#08BAD3' },
      { label: 2, value: 100 - this.completeness, color: '#EBEFF1' }
    ];
  }

  @computed get canUpdateProgress() {
    return this.hasLink('createProgressUpdate');
  }
}

export default Goal;
